<div class="step-panel">

  <div class="pg-title">
    BO approval
    <span class="badge b-a" style="vertical-align:middle;margin-left:8px">Step 7</span>
  </div>
  <div class="pg-sub">
    Business Officer reviews the full credit summary. No data fields editable.
    Decision + mandatory comment only.
  </div>

  <!-- BO Summary Grid -->
  <div class="bo-sum">
    <div class="bo-block">
      <div class="bo-bt">Applicant snapshot</div>
      <div class="bo-row"><span class="bo-k">Name</span><span class="bo-v">{{ applicationData?.userName || userKycData?.name || '—' }}</span></div>
      <div class="bo-row"><span class="bo-k">DOB</span><span class="bo-v">{{ userKycData?.dateOfBirth ? (userKycData?.dateOfBirth | date:'dd MMM yyyy') : '—' }}</span></div>
      <div class="bo-row"><span class="bo-k">Occupation</span><span class="bo-v">{{ userKycData?.occupationType || '—' }}</span></div>
      <div class="bo-row"><span class="bo-k">Employer</span><span class="bo-v">{{ userKycData?.otherDetail1 || '—' }}</span></div>
      <div class="bo-row"><span class="bo-k">Income (declared)</span><span class="bo-v ok">₹{{ userKycData?.monthlyIncome || 0 }}/month</span></div>
      <div class="bo-row"><span class="bo-k">KYC status</span><span class="bo-v ok">{{ userKycData?.isAadharVerified ? '✓ eKYC verified' : 'Pending' }}</span></div>
    </div>

    <div class="bo-block">
      <div class="bo-bt">Credit signals</div>
      <div class="bo-row"><span class="bo-k">Bureau score</span><span class="bo-v">From bureau step</span></div>
      <div class="bo-row"><span class="bo-k">Application status</span><span class="bo-v ok">{{ applicationData?.applicationStatus || '—' }}</span></div>
      <div class="bo-row"><span class="bo-k">Product</span><span class="bo-v">{{ applicationData?.productCode || '—' }}</span></div>
    </div>

    <div class="bo-block">
      <div class="bo-bt">Loan offer (engine output)</div>
      <div class="bo-row"><span class="bo-k">Requested amount</span><span class="bo-v">₹{{ applicationData?.requestedAmount || '75,000' }}</span></div>
      <div class="bo-row"><span class="bo-k">Engine decision</span><span class="bo-v ok">{{ applicationData?.applicationStatus || 'APPROVE' }}</span></div>
      <div class="bo-row"><span class="bo-k">Product Code</span><span class="bo-v">{{ applicationData?.productCode || 'N/A' }}</span></div>
      <div class="bo-row"><span class="bo-k">Tenure</span><span class="bo-v">{{ applicationData?.tenureMonths || '12' }} months</span></div>
      <div class="bo-row"><span class="bo-k">Monthly EMI</span><span class="bo-v">₹{{ (applicationData?.requestedAmount || 75000) / (applicationData?.tenureMonths || 12) | number:'1.0-0' }} (estimated)</span></div>
      <div class="bo-row"><span class="bo-k">Processing fee</span><span class="bo-v">₹1,770 (incl. GST)</span></div>
    </div>
  </div>

  <!-- BO DECISION CARD -->
  <div class="card">
    <div class="card-title">
      <div class="ct-bar"></div>
      BO decision
    </div>

    <div class="alert info">
      <span style="flex-shrink:0">ℹ</span>
      <span>BO can approve, add conditions, or decline. Comment is mandatory if
        overriding the engine decision. All BO actions are logged with BO user ID,
        timestamp, and reason.</span>
    </div>

    <div class="fl" style="margin-bottom:13px">
      <label>BO decision <span class="req">*</span></label>
      <div class="pill-row" style="margin-top:4px">
        <label class="pill" [class.sel]="boDecision==='approve'" (click)="boDecision='approve'">
          <input type="radio" name="bo">✓ Approve
        </label>
        <label class="pill" [class.sel]="boDecision==='decline'" (click)="boDecision='decline'">
          <input type="radio" name="bo">✕ Decline
        </label>
      </div>
    </div>

    <div class="fg c2" *ngIf="boDecision==='approve'" style="margin-bottom:13px">
      <div class="fl">
        <label>Approved amount (₹) <span class="req">*</span></label>
        <input type="number" [(ngModel)]="approvedAmount">
      </div>
      <div class="fl">
        <label>Interest rate (% p.a.)</label>
        <input type="number" [(ngModel)]="interestRate" step="0.01" placeholder="e.g. 14.5">
      </div>
      <div class="fl">
        <label>Tenure (months)</label>
        <input type="number" [(ngModel)]="tenureOverride">
      </div>
    </div>

    <div class="fl" style="margin-bottom:13px">
      <label>BO comment <span class="req">*</span> (mandatory — logged with BO user ID)</label>
      <textarea [(ngModel)]="boComment" rows="3"
        placeholder="Add your review comment or reason for override. Required for all BO decisions. Logged with BO-001 Arun K. + timestamp.">
      </textarea>
    </div>

    <div class="fl">
      <label>Override reason code (if overriding engine)</label>
      <select [(ngModel)]="overrideCode">
        <option>— Not overriding engine decision —</option>
        <option>CC007 — Co-applicant waived (sufficient income)</option>
        <option>CC001 — FOIR borderline — approved on strong income</option>
        <option>CC003 — Income partially verified — approved on bureau strength</option>
      </select>
    </div>
  </div>

  <!-- NAV BAR (custom for BO) -->
  <div class="nav-bar" style="margin-top:20px;padding-top:18px;border-top:1px solid rgba(0,0,0,0.08)">
    <button class="btn btn-sec" (click)="prev.emit()">← Back</button>
    <button class="btn btn-pri btn-lg" (click)="submitDecision()" [disabled]="isSubmitting">
      <span *ngIf="!isSubmitting">Submit Decision →</span>
      <span *ngIf="isSubmitting">Submitting...</span>
    </button>
  </div>

</div>
